import React from 'react';
import { compose } from 'redux';
import { RESORT_RECOMMENDATIONS } from 'Cms/constants';
import { COLORS } from 'Components/utils/color/colors';
import { getProductProps, setProductHref } from 'Components/widgets/product/Product.mapper';
import { useAppContext } from 'Context/ReactAppContext';
import type { ThumbnailProduct } from 'Utils/resort-thumbnail-query/resortThumbnailQuery';
import { SiteContainer } from 'Components/frameworks/site-container/SiteContainer';
import { LineTitle } from 'Components/widgets/line-title/LineTitle';
import { ProductsGrid } from 'Components/widgets/products-grid/ProductsGrid';
type Props = {
  config: {
    common: {
      close: string;
      recommendedResorts: string;
    };
    price: CMSPrice;
    resort: CMSResort;
  };
  recommendations?: {
    products: Array<ThumbnailProduct>;
  };
};
export const ProductRecommendationsLine = (props: Props) => {
  const appContext = useAppContext();

  if (appContext.isSeller || !props.config) {
    return null;
  }

  const { config, recommendations } = props;
  const recommendedProducts = (recommendations?.products || []).map((product) =>
    compose(
      getProductProps,
      setProductHref,
    )({
      config,
      product,
    }),
  );
  const seeMore = {
    color: COLORS.BLACK,
    label: config.resort.moreResultsLabels.buttonLabel,
    text: config.resort.moreResultsLabels.label,
  };
  const title = config.common.recommendedResorts;
  return (
    <SiteContainer className="Line">
      {!!title && <LineTitle>{title}</LineTitle>}
      <ProductsGrid
        hasSeeMore
        isSynchronousGrid
        lineName={RESORT_RECOMMENDATIONS}
        products={recommendedProducts}
        seeMore={seeMore}
      />
    </SiteContainer>
  );
};
